<template>
  <div class="document-wrapper"
       :style="`background: white; display: block; margin: 1cm auto; padding: 50px; box-shadow: rgba(0, 0, 0, 0.5) 0px 0px 0.5cm; max-width: ${maxWidth}; min-height: 20cm; position: relative;`"
  >
    <button style="position: absolute; top: 10px; right: 10px;" class="btn btn-link" type="button"
            @click.prevent="print()" v-if="showPrintButton"><i class="fas fa-print"></i></button>
    <slot class="is-it-a-class"></slot>
    <!--    <ks-qr-code textValue="http://www.kizanpro.com/tasks"/>-->
  </div>
</template>

<script>
export default {
  name:    'ks-document-wrapper',
  props:   {
    maxWidth:        {
      type:    String,
      default: '24cm'
    },
    print_id:        {
      type:    String,
      default: ''
    },
    showPrintButton: {
      type:    Boolean,
      default: true
    }
  },
  methods: {
    print() {
      if (!this.print_id) return;

      var mywindow = window.open('', 'PRINT', 'height=400,width=600');

      // <link rel="stylesheet" media="print" href="../reports/print.css"/>


      mywindow.document.write(`
        <style>
          p {margin: 0;}
          .pagebreak {page-break-before: always;}
          .row {display: flex;flex-wrap: wrap;}
          .col-12 {flex: 0 0 100%; max-width: 100%;}
          .col-11 {flex: 0 0 91.666667%; max-width: 91.666667%;}
          .col-10 {flex: 0 0 83.333333%; max-width: 83.333333%;}
          .col-9 {flex: 0 0 75%; max-width: 75%;}
          .col-8 {flex: 0 0 66.666667%; max-width: 66.666667%;}
          .col-7 {flex: 0 0 58.333333%; max-width: 58.333333%;}
          .col-6 {flex: 0 0 50%; max-width: 50%;}
          .col-5 {flex: 0 0 41.666667%; max-width: 41.666667%;}
          .col-4 {flex: 0 0 33.333333%; max-width: 33.333333%;}
          .col-3 {flex: 0 0 25%; max-width: 25%;}
          .col-2 {flex: 0 0 16.666667%; max-width: 16.666667%;}
          .col-1 {flex: 0 0 8.333333%; max-width: 8.333333%;}
        </style>
      `);
      mywindow.document.write('<head>');
      mywindow.document.write('</head><body>');
      mywindow.document.write(document.getElementById(this.print_id).innerHTML);
      mywindow.document.write('</body></html>');
      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10*/

      // mywindow.print();
      setTimeout(function () {
        mywindow.print();
        // mywindow.close();
      }, 1000);
    },
  }
}
</script>
<style>
.document-wrapper div p {
  margin: 0;
}

.ql-align-center {
  text-align: center;
}
</style>